<template>
    <div class="w-full h-full flex flex-col">
        <custom-simple-select
            v-model="option"
            label="Tipo de página"
            class="w-full min-w-full"
            :options="options"
            :disabled="!enabled"
            @change="onInput"
        />
    </div>
</template>

<script>
import { blogTypes } from "@/common/fields/blog-types";

import CustomSimpleSelect from "@/components/utils/CustomSimpleSelect.vue";

export default {
    name: "BlogTypesSelector",
    components: {
        CustomSimpleSelect
    },
    model: {
        prop: "itemCurrent",
        event: "change"
    },
    props: {
        itemCurrent: {
            default: () => "tutorial",
            type: String,
            require: true
        },
        enabled: {
            default: () => true,
            type: Boolean,
            required: false
        }
    },
    emits: ["change"],
    data: () => ({
        option: "",
        $enabledOptions: blogTypes
    }),
    computed: {
        options() {
            return Object.entries(this.$data.$enabledOptions).map(
                ([key, value]) => ({ label: value, value: key })
            );
        }
    },
    watch: {
        itemCurrent(value) {
            this.option = value;
        }
    },
    mounted() {
        this.option = this.itemCurrent;
    },
    methods: {
        onInput() {
            this.$emit("change", this.option);
        }
    }
};
</script>
